
import { defineComponent, ref, PropType, computed } from 'vue';
import { getAddress } from '@ethersproject/address';
import useNumbers from '@/composables/useNumbers';
import LiquidityAPRTooltip from '@/components/tooltips/LiquidityAPRTooltip.vue';
import { useRouter } from 'vue-router';
import { DecoratedPool, FullPool } from '@/services/balancer/subgraph/types';

export default defineComponent({
  name: 'PoolCards',

  props: {
    data: {
      type: Array
    },
    incentivizedPools: {
      type: Array as PropType<DecoratedPool[]>
    }
  },

  components: {
    LiquidityAPRTooltip
  },

  setup(props) {
    const { fNum } = useNumbers();
    const router = useRouter();

    function navigateToPool(pool: FullPool) {
      if (props.incentivizedPools?.find((incentivizedPool: DecoratedPool) => incentivizedPool.id === pool.id)) {
        router.push({
          name: 'pool',
          params: { id: pool.id, isIncentivized: btoa('true') }
        });
      } else {
        router.push({
          name: 'pool',
          params: { id: pool.id, isIncentivized: btoa('false') }
        });
      }
    }
    return {
      fNum,
      getAddress,
      navigateToPool
    };
  }
});
